import EditFullScreenView from './containers/EditFullScreenViewContainer'

export default EditFullScreenView
